import styled, { css } from 'styled-components';
import rem from 'polished/lib/helpers/rem';
// template components
import { SectionContainerNm2024  } from '../../../../nm2024Theme/components/sectionContainer/styles';
import { TypographyNm2024  } from '../../../../nm2024Theme/components/typography/styles';
// NM 2024 theme
import Nm2024Theme from '../../../../nm2024Theme/nm2024Theme/colors';
// eslint-disable-next-line import/prefer-default-export
export const SectionContainerNm2024Styled = styled(SectionContainerNm2024)`
  ${({ theme }) => {
    const mediumUp = theme.mediumUp();
    return css`
      &&& {
        background-color: ${Nm2024Theme.sky.sky80};
        padding-bottom: ${mediumUp ? rem(44) : rem(20)};
        .icon-fill {
          fill: ${Nm2024Theme.navy.navy};
        }
      }
    `;
  }
}`;

export const TypographyNm2024Styled = styled(TypographyNm2024)`
  ${({ theme }) => {
    const mediumUp = theme.mediumUp();
    return css`
      && {
        padding-bottom: ${mediumUp ? rem(24) : rem(9)};
      }
    `;
  }}
`;